import { DrawerSize, PanelStack } from "@blueprintjs/core"
import CustomDrawer from "components/Atoms/CustomDrawer"
import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { CLOSE_DISPATCH_DRAWER } from "store/dispatch.redux"
import OrdersPanel from "./drawer/OrdersPanel"
import VehicleCapacityBar from "./VehicleCapacityBar"
const DispatchDrawer = () => {
  const isOpen = useSelector((state: any) => state.dispatch.isOpen)
  const dispatch = useDispatch()
  const [stack, setStack] = useState<any[]>([
    {
      component: OrdersPanel,
      title: "Orders",
    },
  ])
  return (
    <CustomDrawer
      className="vt-dispatch-drawer"
      isOpen={isOpen}
      size={DrawerSize.SMALL}
      hasBackdrop={false}
      autoFocus={false}
      enforceFocus={false}
      canEscapeKeyClose={false}
      canOutsideClickClose={false}
      portalClassName="vt-vehicle-filter-portal"
      drawerClassName="vt-vehicle-module-filter vt-dispatch-module-drawer"
      icon="drive-time"
      title={
        <div>
          <div className="d-center">
            <span className="mr-2">Capacity</span> <VehicleCapacityBar />
          </div>
          {/* <VehicleSelector onBackClick={(e) => {}} /> */}
        </div>
      }
      onClose={e => {
        dispatch({
          type: CLOSE_DISPATCH_DRAWER,
        })
      }}
    >
      <PanelStack
        showPanelHeader={false}
        className="vt-dispatch-panel-stack"
        onOpen={panel => setStack(prev => [...prev, panel])}
        onClose={panel => setStack(prev => prev.filter(p => p !== panel))}
        stack={stack}
      />{" "}
    </CustomDrawer>
  )
}

export default DispatchDrawer
